var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import { makeStyles } from "../../styles/index";
import { Checkbox, MoreVert } from "../../index";
import { useMeasure } from "../../hooks/useMeasure";
var DraggableHandle = SortableHandle(function (_a) {
    var children = _a.children;
    return children;
});
var styles = function (theme) { return ({
    ellipsis: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    checkbox: {
        backgroundColor: theme.palette.common.white,
    },
}); };
var useStyles = makeStyles(styles, { name: 'SnDataListTableCell' });
export var DataListTableCell = function (props) {
    var cellProps = props.cellProps, selected = props.selected, handleSize = props.handleSize;
    var rowIndex = cellProps.rowIndex, cellData = cellProps.cellData, column = cellProps.column, rowData = cellProps.rowData;
    var classes = useStyles();
    var handleStyle = useMeasure({
        width: handleSize,
        minWidth: handleSize,
    }).style;
    if (rowData.blank && column.format !== 'rowIndex') {
        // rowIndex以外でデータが空の時は何も表示しない
        return null;
    }
    switch (column.format) {
        case 'rowIndex':
            return React.createElement("div", { className: classes.ellipsis }, rowIndex + 1);
        case 'checkbox':
            if (selected === undefined) {
                // データがまだ無い時
                // チェックボックスを操作されると表示が不正になる可能性があるため何も表示しない
                return null;
            }
            return React.createElement(Checkbox, { classes: { border: classes.checkbox }, value: selected });
        case 'handle':
            return (React.createElement(DraggableHandle, null,
                React.createElement(MoreVert, { style: __assign({}, handleStyle) })));
        default:
            return React.createElement("div", { className: classes.ellipsis }, cellData);
    }
};
